// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"273ce3ef","393":"8a62727c","584":"e028fc66","597":"25e34fe8","761":"a341d1cd","787":"8493df1b","822":"16e11a14"}[chunkId] + ".chunk.js";
};